import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TransferApp } from './TransferApp';
import '../styles.css';

// Entry des schlanken Transfer-Clients (transfer.greenforce.com, Phase 2).
// Eigener Vite-Build (BUILD_TARGET=transfer → dist/client-transfer/) mit einem
// eigenen Module-Graph → nur Login + TransferPage, kein DAM-Code (App.tsx-Surface
// wird bewusst NICHT importiert). Prod serviert index-transfer.ts das Bundle.
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index-transfer.html');

createRoot(rootEl).render(
  <StrictMode>
    <TransferApp />
  </StrictMode>,
);
